import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-home-view",
  templateUrl: "./home-view.component.html",
  styleUrls: ["./home-view.component.scss"],
})
export class HomeViewComponent implements OnInit {
  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit() {
    this.titleService.setTitle(
      "Union Solutions | Soluções Inteligentes em Consultas e Vistorias Veiculares"
    );
    this.metaService.updateTag({
      name: "description",
      content:
        "Consultas veiculares, vistorias, análise de crédito, gestão de seminovos e soluções personalizadas para empresas do setor automotivo. A Union oferece tecnologia e segurança para decisões mais assertivas.",
    });
  }
}
